/**
 * Format file size in bytes to human-readable format
 * @param {number} bytes - File size in bytes
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted file size (e.g., "1.5 MB")
 */
export function formatFileSize(bytes, decimals = 2) {
    if (!bytes || bytes === 0) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
}

/**
 * Convert MB to human-readable format
 * @param {number} mb - Size in megabytes
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted size
 */
export function formatMB(mb, decimals = 2) {
    if (!mb || mb === 0) return '0 MB';
    if (mb < 1024) return `${mb.toFixed(decimals)} MB`;
    return `${(mb / 1024).toFixed(decimals)} GB`;
}

/**
 * Get color based on storage percentage
 * @param {number} percent - Percentage used (0-100)
 * @returns {string} Color: 'success', 'warning', or 'error'
 */
export function getStorageColor(percent) {
    if (percent < 70) return 'success';
    if (percent < 95) return 'warning';
    return 'error';
}
